import React from 'react';
import { PaneContentWrapper } from './PaneContentWrapper';
import { PanesContentSelector } from './PaneSelector';
import { Box, Stack, Typography } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import { Edit as EditIcon, Add as AddIcon } from '@mui/icons-material';
import { translate as t } from 'hooks/useTranslations';
import { ModalAction } from '../../PolicyEditor';

interface HeaderPanesProps {
  activePaneId: string;
  handleOpenModals?: (panel: 'guideSheet' | 'releaseNotes', action?: ModalAction) => void;
  releaseNotes?: {
    amountOfReleaseNotes: number;
    showControls?: boolean;
  };
  guideSheet?: {
    showControls?: boolean;
  };
}

export const Header = ({ activePaneId, handleOpenModals, releaseNotes, guideSheet }: HeaderPanesProps) => {
  return (
    <PanesContentSelector activePaneId={activePaneId}>
      <PaneContentWrapper paneId='guideSheet'>
        <Stack
          direction='row'
          alignItems='center'
          justifyContent='space-between'
          width='100%'
        >
          <Typography variant='subtitleMd'>{t('draftManuals.guideSheet.title')}</Typography>
          {guideSheet?.showControls && (
            <Tooltip title={t('draftManuals.guideSheet.editTooltip')}>
              <span>
                <IconButton
                  aria-label={t('draftManuals.guideSheet.editAria')}
                  size='small'
                  onClick={handleOpenModals ? () => handleOpenModals('guideSheet') : undefined}
                >
                  <EditIcon />
                </IconButton>
              </span>
            </Tooltip>
          )}
        </Stack>
      </PaneContentWrapper>
      <PaneContentWrapper paneId='releaseNotes'>
        <Stack
          direction='row'
          alignItems='center'
          justifyContent='space-between'
          width='100%'
        >
          <Typography variant='subtitleMd'>{t('draftManuals.releaseNotes.title')}</Typography>
          {releaseNotes?.showControls && (
            <Box>
              <Tooltip title={t('draftManuals.releaseNotes.addReleaseNotes')}>
                <span>
                  <IconButton
                    aria-label={t('draftManuals.releaseNotes.addAria')}
                    size='small'
                    onClick={handleOpenModals ? () => handleOpenModals('releaseNotes', 'CREATE') : undefined}
                  >
                    <AddIcon />
                  </IconButton>
                </span>
              </Tooltip>
              {releaseNotes && releaseNotes.amountOfReleaseNotes > 0 && (
                <Tooltip title={t('draftManuals.releaseNotes.editReleaseNotes')}>
                  <span>
                    <IconButton
                      aria-label={t('draftManuals.releaseNotes.editReleaseNotesAria')}
                      size='small'
                      onClick={handleOpenModals ? () => handleOpenModals('releaseNotes', 'EDIT') : undefined}
                    >
                      <EditIcon />
                    </IconButton>
                  </span>
                </Tooltip>
              )}
            </Box>
          )}
        </Stack>
      </PaneContentWrapper>
      <PaneContentWrapper paneId='pendingUpdates'>
        <Stack
          direction='row'
          alignItems='center'
          justifyContent='space-between'
          width='100%'
        >
          <Typography variant='subtitleMd'>{t('draftManuals.reviewUpdates.pendingUpdates', 'Pending Updates')}</Typography>
        </Stack>
      </PaneContentWrapper>
    </PanesContentSelector>
  );
};
